// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2680":"baf4a0fa","5478":"9f8c2894"}[chunkId] + ".chunk.css";
};